import React from 'react'
import { colors } from 'pixel-base'

export const shopifyIconDotcom = (
  <svg
    fill={colors.primary}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="48px"
    height="48px"
  >
    <path d="M 9.0253906 1 C 8.4771811 1 7.9869341 1.2551676 7.6308594 1.5800781 C 7.2747847 1.9049886 7.0116264 2.3049244 6.7871094 2.7597656 C 6.419507 3.5044784 6.1640451 4.4172783 6.0039062 5.4414062 L 3.3125 6.2402344 L 1.3300781 20.601562 L 14.507812 23.017578 L 14.693359 22.980469 L 22.683594 21.412109 L 20.089844 4.5996094 L 15.386719 2.6601562 L 14.380859 2.9589844 C 14.21929 2.6374669 14.038621 2.3383213 13.828125 2.0742188 C 13.356371 1.4823247 12.675562 1 11.853516 1 C 11.276705 1 10.805419 1.272447 10.390625 1.6191406 C 10.017225 1.277114 9.5836469 1 9.0253906 1 z M 9.0253906 3 C 8.9608854 3 9.047691 2.9742917 9.2558594 3.2714844 C 9.411183 3.493233 9.5778658 3.883755 9.7304688 4.3378906 L 8.1699219 4.8007812 C 8.2895591 4.3389782 8.4316818 3.9451621 8.5800781 3.6445312 C 8.7276861 3.3454976 8.8825591 3.1441989 8.9785156 3.0566406 C 9.0744722 2.9690824 9.0686002 3 9.0253906 3 z M 11.853516 3 C 11.895466 3 12.025676 3.021706 12.263672 3.3203125 C 12.307557 3.3753743 12.35309 3.4763757 12.398438 3.546875 L 11.613281 3.7792969 C 11.546007 3.6428945 11.477888 3.5094745 11.419922 3.3613281 C 11.656274 3.0587037 11.810998 3 11.853516 3 z M 14.53125 5 L 13.570312 20.8125 L 3.5742188 18.980469 L 5.1171875 7.7910156 L 14.53125 5 z M 16.517578 5.2890625 L 18.285156 6.0175781 L 20.414062 19.820312 L 15.578125 20.769531 L 16.517578 5.2890625 z M 10.390625 9.0039062 C 8.016625 9.0039062 6.8457031 10.605766 6.8457031 12.259766 C 6.8457031 14.235766 8.7773438 14.286422 8.7773438 15.482422 C 8.7773438 15.773422 8.5713594 16.169922 8.0683594 16.169922 C 7.3073594 16.169922 6.4042969 15.378906 6.4042969 15.378906 L 5.9414062 16.917969 C 5.9414062 16.917969 6.80525 18 8.53125 18 C 9.96025 18 11.017578 16.907891 11.017578 15.212891 C 11.017578 13.060891 8.6542969 12.707969 8.6542969 11.792969 C 8.6542969 11.626969 8.707625 10.949219 9.765625 10.949219 C 10.474625 10.949219 11.070312 11.271484 11.070312 11.271484 L 11.728516 9.265625 C 11.728516 9.265625 11.275625 8.9939062 10.390625 9.0039062 z" />
  </svg>
)
export const shopifyIconDotcom1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="48px"
    height="48px"
    stroke={colors.primary}
    strokeWidth="1.5"
    fill="none"
  >
    <path d="M6,8 L6,18 L18,18 L18,8 Z" />

    <path d="M18,8 L20,6 L20,16 L18,18" strokeOpacity="0.8" />

    <path d="M6,8 L8,6 L20,6 L18,8" strokeOpacity="0.9" />

    <path d="M8,8 C8,5.5 9.5,4 12,4 C14.5,4 16,5.5 16,8" />

    <path
      d="M10,6 C10,3.5 11.5,2 14,2 C16.5,2 18,3.5 18,6"
      strokeOpacity="0.6"
      strokeDasharray="2,1"
    />

    <path d="M8,5.5 L10,3.5" strokeOpacity="0.7" />
    <path d="M16,5.5 L18,3.5" strokeOpacity="0.7" />
  </svg>
)
export const UniversalStoreIcon = (
  <svg
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    {/* Store building base */}
    <path
      d="M40 80V160H160V80"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-primary"
    />

    {/* Roof */}
    <path
      d="M20 80L100 40L180 80"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-primary"
    />

    {/* Door */}
    <path
      d="M85 160V120H115V160"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-primary"
    />

    {/* Windows */}
    <path
      d="M60 100H75M125 100H140"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      className="text-primary"
    />

    {/* Shopping bag handle */}
    <path
      d="M85 90C85 85 90 80 100 80C110 80 115 85 115 90"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      className="text-primary"
    />
  </svg>
)

interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string
  opacity?: number
  onClick?: React.MouseEventHandler<SVGSVGElement>
  tooltip?: string
  size?: number
}

export const OrdersIcon = ({
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    {/* Clipboard outline */}
    <path
      d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Clipboard top */}
    <path
      d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Checklist items */}
    <path
      d="M9 12H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M9 16H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M9 12L8 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M9 16L8 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CustomersIcon = ({
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 21C20 16.5817 16.4183 13 12 13C7.58172 13 4 16.5817 4 21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SettingsIcon = ({
  tooltip,
  onClick,
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity, cursor: 'pointer' }}
    {...props}
  >
    {tooltip && <title>{tooltip}</title>}
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PaymentsIcon = ({
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    <path
      d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10H23"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ProductsInventoryIcon = ({
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    <path
      d="M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.27002 6.96002L12 12.01L20.73 6.96002"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 22.08V12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LocationsIcon = ({
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    <path
      d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
// Updated AnalyticsIcon with 2D blocks and more space between them
export const AnalyticsIcon = ({
  color = colors.white,
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    {/* Base line */}
    <path
      d="M2 20H22"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* First (shortest) block */}
    <rect
      x="3"
      y="14"
      width="4"
      height="6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Second (medium) block */}
    <rect
      x="10"
      y="10"
      width="4"
      height="10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Third (tallest) block */}
    <rect
      x="17"
      y="4"
      width="4"
      height="16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const AllStoresIcon = ({
  color = 'rgb(248, 248, 249)',
  opacity = 0.9,
  ...props
}: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, opacity }}
    {...props}
  >
    {/* First store (left) */}
    <path
      d="M3 21V11M3 11L5 7H10L12 11M3 11H12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Door for first store */}
    <path
      d="M6 21V17H9V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Second store (middle) */}
    <path
      d="M12 21V11M12 11L14 7H19L21 11M12 11H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Door for second store */}
    <path
      d="M15 21V17H18V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Base line */}
    <path
      d="M2 21H22"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* Small store (background) */}
    <path
      d="M7 7V4H17V7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AccountCardIcon = ({
  color = 'rgb(248, 248, 249)',
  strokeWidth = 2,
  className = '',
  opacity = 0.9,
  ...props
}: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color, opacity }}
      {...props}
    >
      {/* ID Card */}
      <rect x="2" y="4" width="20" height="16" rx="2" />

      {/* User photo area */}
      <circle cx="8" cy="10" r="2.5" />

      {/* Text lines */}
      <path d="M13 8H19" />
      <path d="M13 12H19" />
      <path d="M13 16H16" />

      {/* Card details */}
      <path d="M6 16H10" />
    </svg>
  )
}
